import { useEffect, useMemo, useRef, useState } from 'react';
import './Dashboard.css';

const TV_SCRIPT_SRC = 'https://s3.tradingview.com/tv.js';

let tvScriptPromise = null;

function loadTradingView() {
    if (window.TradingView) return Promise.resolve();
    if (tvScriptPromise) return tvScriptPromise;
    tvScriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = TV_SCRIPT_SRC;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
            tvScriptPromise = null;
            script.remove();
            reject(new Error('Failed to load TradingView script'));
        };
        document.body.appendChild(script);
    });
    return tvScriptPromise;
}

/**
 * props:
 * - symbol
 */
function CandleChart(props) {
    const [failed, setFailed] = useState(false);
    const widgetRef = useRef(null);

    useEffect(() => {
        let cancelled = false;
        setFailed(false);
        loadTradingView()
            .then(() => {
                if (cancelled || !window.TradingView) return;
                const container = document.getElementById('tradingview_d34df');
                if (container) container.innerHTML = '';
                widgetRef.current = new window.TradingView.widget({
                    symbol: 'BINANCE:' + props.symbol,
                    autosize: true,
                    interval: '1',
                    timezone: 'Etc/UTC',
                    theme: 'dark',
                    style: '1',
                    locale: 'en',
                    toolbar_bg: '#f1f3f6',
                    enable_publishing: false,
                    allow_symbol_change: true,
                    details: true,
                    withdateranges: true,
                    hide_side_toolbar: false,
                    studies: ['RSI@tv-basicstudies'],
                    container_id: 'tradingview_d34df',
                });
            })
            .catch(() => {
                if (!cancelled) setFailed(true);
            });
        return () => {
            cancelled = true;
        };
    }, [props.symbol]);

    const widgetHtml = useMemo(() => {
        return (
            <div className="row">
                <div className="col-12 mb-4">
                    <div
                        className="card cardDark border-0 shadow"
                        style={{ height: 520 }}
                    >
                        <div className="card-body p-2">
                            {failed ? (
                                <div className="d-flex h-100 align-items-center justify-content-center">
                                    <p className="text-muted mb-0">
                                        Unable to load the TradingView chart.
                                        Check your connection or disable content
                                        blockers for this page.
                                    </p>
                                </div>
                            ) : (
                                <div className="tradingview-widget-container ">
                                    <div
                                        id="tradingview_d34df"
                                        className="divTradingView"
                                    ></div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }, [failed]);

    return widgetHtml;
}

export default CandleChart;
